// src/api/productImages.ts
import { API_BASE_URL, ASSET_HOST } from "../config";
import { getAdminToken } from "../auth";

const joinUrl = (base: string, path: string) =>
  `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;

export async function uploadProductImages(
  files: File[],
  kind: "rotation" | "gallery",
): Promise<string[]> {
  if (!files.length) return [];

  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files[]", file);
  });
  formData.append("kind", kind);

  const token = getAdminToken();

  const res = await fetch(`${API_BASE_URL}/admin/product_images`, {
    method: "POST",
    body: formData,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Upload failed: ${res.status} ${text}`);
  }

  const json = await res.json();
  return json.images || [];
}

export function buildProductImageUrl(path: string): string {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  // ✅ use R2 for uploaded assets
  if (ASSET_HOST && path.startsWith("/uploads/")) {
    return joinUrl(ASSET_HOST, path);
  }

  // fallback
  return joinUrl(API_BASE_URL, path);
}
